import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Modal, Table, TableBody, TableCell, AppBar, CircularProgress, Typography, Toolbar, Box, Container, InputAdornment, TableHead, TableRow, Paper, TextField } from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import Tooltip from '@mui/material/Tooltip';
import base64 from 'base64-js';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const Designation = () => {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  let navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredDesignations, setFilteredDesignations] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState({ designationId: null, designationName: '' });
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [authorization, setAuthorization] = useState([]);
  const [canDelete, setCanDelete] = useState(true); // Default to true, assuming user can delete
  const [canEdit, setCanEdit] = useState(true);
  const [canAdd, setCanAdd] = useState(true);

  const { encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };
  const formId = decodeFormId(encodedFormId);
  console.log(formId);

  const handleClose = () => setShowModal(false);

  const handleShow = (desigId, designationName) => {
    setSelectedDesignation({ desigId, designationName });
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(
        `${apiUrl}/Designation/Id?DesigId=${selectedDesignation.desigId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        }
      );

      if (response.ok) {
        // Handle success, e.g., refresh the data
        fetchDesignationData();
        setShowModal(false);
        setSnackbarMessage('Designation deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success")
      } else {
        console.error('Delete failed');
        // alert('Failed to delete designation');
        setSnackbarMessage('Failed to delete designation');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const fetchDesignationData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const connectionString = sessionStorage.getItem('ConnectionString');
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Designation/DesignationName`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (response.ok) {
        const responseData = await response.json();
        setDesignations(responseData);
        setLoadingBarProgress(100);
      } else {
        console.error('Designation name incorrect');
        // alert('Invalid designation name'); // Corrected error message
        setSnackbarMessage('Invalid designation name');
      setOpenSnackbar(true);
      setSnackbarSeverity("warning");
        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          formId,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData);
        // Check permissions for Delete and Edit
        const authorizationData = responseData[0];
        setCanDelete(authorizationData.uDelete === 1);
        setCanEdit(authorizationData.uModify === 1);
        setCanAdd(authorizationData.uWrite === 1);
        setLoadingBarProgress(100);
      } else {
        console.error('Country name incorrect');
        // alert('Invalid country name');
        setSnackbarMessage('Invalid country name');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  useEffect(() => {
    fetchDesignationData();
    Authorizer();
  }, []);

  useEffect(() => {
    if (designations && Array.isArray(designations)) {
      setFilteredDesignations(
        designations.filter((designation) =>
          designation.designationName.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setFilteredDesignations([]);
    }
  }, [searchTerm, designations]);

  const handleSearch = () => {
    setFilteredDesignations(
      designations.filter((designation) =>
        designation.designationName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  const paginatedData = filteredDesignations.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1); // reset to page 1
  };

  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: "bold" }}>
            Designation
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
        <div className="container mt-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
          <TextField
            variant="outlined"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "300px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">

                  <SearchIcon />
                </InputAdornment>
              ),
              style: { padding: '0px 8px' },
            }}
            sx={{
              width: 300,
              backgroundColor: '#f9f9f9',
            }}
          />
          <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow><span>

            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/AddDesignation')}
              style={{
                width: "160px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
              disabled={!canAdd}
            >
              ADD DESIGNATION
            </Button></span></Tooltip>
          {/* <Button
    variant="outlined"
    color="info"
    sx={{ marginLeft: '1rem', height: 'fit-content' }} // Same spacing and height
    onClick={handleSearch}
  >
    Search
  </Button> */}
        </div>


        <Table
          sx={{
            minWidth: 650,
            border: '1px solid #ccc',
            '& .MuiTableCell-root': {
              borderRight: '1px solid #ccc', // vertical line
              fontSize: '1rem', // increased font size
            },
            '& .MuiTableHead-root .MuiTableCell-root': {
              fontWeight: 'bold',
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ fontSize: '1rem', fontWeight: 'bold', borderRight: '2px solid #ddd' }}>
                Department Name
              </TableCell>
              <TableCell style={{ fontSize: '1rem', fontWeight: 'bold', borderRight: '2px solid #ddd' }}>
                Designation Name
              </TableCell>
              <TableCell style={{ fontSize: '1rem', fontWeight: 'bold', textAlign: 'center' }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingBarProgress > 0 && loadingBarProgress < 100 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((designation) => (
                <TableRow key={designation.desigId}>
                  <TableCell style={{ borderRight: '2px solid #ddd', fontSize: '0.95rem' }}>
                    {designation.departmentName}
                  </TableCell>
                  <TableCell style={{ borderRight: '2px solid #ddd', fontSize: '0.95rem' }}>
                    {designation.designationName}
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '0.95rem' }}>
                    <Tooltip title={canEdit ? '' : 'You are not authorized to edit'} arrow>
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={() => navigate(`/EditDesignation/${designation.desigId}`)}
                        disabled={!canEdit}
                        startIcon={<EditIcon />}
                        style={{ marginRight: '5px' }}
                      >
                        Edit
                      </Button>
                    </Tooltip>
                    <Tooltip title={canDelete ? '' : 'You are not authorized to delete'} arrow>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleShow(designation.desigId, designation.designationName)}
                        disabled={!canDelete}
                        startIcon={<DeleteIcon />}
                      >
                        Delete
                      </Button>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  Record not found
                </TableCell>
              </TableRow>
            )}
          </TableBody>

        </Table>

        {filteredDesignations.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
            <TextField
              select
              label="Rows per page"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              sx={{ width: 150 }}
              SelectProps={{
                native: true,
              }}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </TextField>

            <Box>
              <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
                Page {page} of {Math.ceil(filteredDesignations.length / rowsPerPage)}
              </Typography>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page - 1)}
                disabled={page === 1}
                sx={{ mr: 1 }}
              >
                Prev
              </Button>
              <Button
                variant="outlined"
                onClick={() => handleChangePage(null, page + 1)}
                disabled={page >= Math.ceil(filteredDesignations.length / rowsPerPage)}
              >
                Next
              </Button>
            </Box>
          </Box>
        )}


        {/* Delete Confirmation Modal */}
        <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              borderRadius: 2,
              boxShadow: 24,
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
              <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                Delete Confirmation ⚠️
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: '20px' }}>
              <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                Are you sure you want to delete <strong>{selectedDesignation.designationName}</strong>?
              </Typography>

              {/* Buttons */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleDelete(handleDelete)}
                >
                  Yes, Delete
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default Designation;
// {selectedDesignation.designationName}
